/**
 * index.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

export { Identifiable, Tagged } from "app/support/types/aliases";
export { Message } from "./general/message";
export { MessageTag } from "./message-tag";



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/index.ts